<template>
  <div class="appointment-body">
    <div class="tab-name">
      <div class="name-inner">
        <span>1</span>
        任用資訊
      </div>
    </div>

    <div class="field">
      <span>應徵姓名</span>
      <div>{{ appointment.Name }}</div>
    </div>

    <div class="field">
      <span>身份別</span>
      <div>{{ appointment.IdentityType }}</div>
    </div>

    <div class="field">
      <span>錄用類型</span>
      <div>{{ appointment.EmployCategory }}</div>
    </div>

    <div class="field">
      <span>薪制</span>
      <div>{{ appointment.SalaryType }}</div>
    </div>

    <div class="field">
      <span>任用部門</span>
      <div>
        {{
          appointment.AppointmentDepartment
            ? appointment.AppointmentDepartment.Name
            : null
        }}
        {{
          appointment.AppointmentPlant
            ? appointment.AppointmentPlant.Name
            : null
        }}
      </div>
    </div>

    <div class="field">
      <span>最高學歷</span>
      <div>{{ appointment.HighestEducation }}</div>
    </div>

    <div class="field">
      <span>學校</span>
      <div>{{ appointment.School }}</div>
    </div>

    <div class="field">
      <span>科系</span>
      <div>{{ appointment.Department }}</div>
    </div>

    <div
      v-if="
        !(appointment.ResumeType === 'IDL' && appointment.SalaryType === '月薪')
      "
      class="field"
    >
      <span>Offer 顯示單位</span>
      <div>{{ appointment.OfferDisplayDepartment }}</div>
    </div>

    <div
      v-if="
        !(appointment.ResumeType === 'IDL' && appointment.SalaryType === '月薪')
      "
      class="field"
    >
      <span>報到日期</span>
      <div>{{ $common.dateFormatter(appointment.OnBoardTime) }}</div>
    </div>

    <div class="tab-name">
      <div class="name-inner">
        <span>2</span>
        任用建議
      </div>
    </div>

    <div class="field">
      <span>職缺名稱</span>
      <div>{{ appointment.PositionName }}</div>
    </div>

    <div
      v-if="
        !(appointment.ResumeType === 'IDL' && appointment.SalaryType === '月薪')
      "
      class="field"
    >
      <span>任用職稱</span>
      <div>{{ appointment.AppointmentPosition }}</div>
    </div>

    <div
      v-if="
        !(appointment.ResumeType === 'IDL' && appointment.SalaryType === '月薪')
      "
      class="field"
    >
      <span>職等</span>
      <div>{{ appointment.Rank }}</div>
    </div>

    <div
      v-if="
        appointment.ResumeType === 'DL' && appointment.SalaryType === '月薪'
      "
      class="field"
    >
      <span>月薪</span>
      <div>{{ appointment.BasicSalary }}</div>
    </div>

    <div v-if="appointment.SalaryType === '時薪'" class="field">
      <span>時薪</span>
      <div>{{ appointment.HourSalary }}</div>
    </div>

    <template
      v-if="
        !(appointment.ResumeType === 'IDL' && appointment.SalaryType === '月薪')
      "
    >
      <div class="field">
        <span>聘僱期間</span>
        <div>
          {{ $common.dateFormatter(appointment.EmploymentStart) }}~{{
            $common.dateFormatter(appointment.EmploymentEnd)
          }}
        </div>
      </div>

      <div class="field">
        <span>工作時間</span>
        <div>{{ appointment.WorkTimeType }}</div>
      </div>

      <div class="field" v-if="appointment.WorkTimeType === '一般工時'">
        <span>班別</span>
        <div>{{ appointment.WorkShiftType }}</div>
      </div>
    </template>

    <template
      v-if="
        appointment.WorkShiftTypeGuid === '11111111-1111-1111-1111-111111111111'
      "
    >
      <div class="field">
        <span>班別描述</span>
        <div>{{ appointment.WorkShiftTypeDesc }}</div>
      </div>

      <div class="field">
        <span>休息分鐘數</span>
        <div>{{ appointment.BreakMinute }}</div>
      </div>

      <div class="field">
        <span>每日工時</span>
        <div>{{ appointment.DailyWorkHour }}</div>
      </div>

      <div class="field">
        <span>每週工時</span>
        <div>{{ appointment.WeeklyWorkHour }}</div>
      </div>
    </template>

    <div v-if="appointment.WorkTimeType === '特殊工時'" class="field">
      <span>出勤類型</span>
      <div>{{ appointment.SpecialWorkTimeType }}</div>
    </div>

    <template v-if="appointment.SpecialWorkTimeType === '約定工時'">
      <div class="field">
        <span>約定週工時</span>
        <div>{{ appointment.SpecialWeeklyHour }}</div>
      </div>

      <div class="field">
        <span>約定月工時</span>
        <div>{{ appointment.SpecialMonthlyHour }}</div>
      </div>
    </template>

    <div class="field">
      <span>其他說明</span>
      <div>{{ appointment.Description }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppointmentRecord",
  props: ["MatchId"],
  data() {
    return {
      appointment: {},
    };
  },

  methods: {
    // 取得 任用單
    getAppointmentForm() {
      this.$api.appointment.getAppointment(this.MatchId).then((response) => {
        if (response.status === 200) {
          this.appointment = response.data;
        }
      });
    },
  },

  watch: {
    // 月薪
    "appointment.BasicSalary": function (newVal) {
      if (newVal) {
        this.appointment.BasicSalary = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },

    // 時薪
    "appointment.HourSalary": function (newVal) {
      if (newVal) {
        this.appointment.HourSalary = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },
  },

  created() {
    this.getAppointmentForm();
  },
};
</script>

<style lang="scss" scoped>
$color1: #636f83;
.appointment-body {
  .tab-name {
    text-align: center;
    background-color: $color1;
    padding: 10px 0;
    border-radius: 5px;
    margin-bottom: 10px;

    .name-inner {
      display: inline-block;
      background-color: #fff;
      color: $color1;
      position: relative;
      padding: 3px 15px;
      border-radius: 0 25px 25px 0;
      letter-spacing: 2px;

      span {
        color: #fff;
        font-size: 3em;
        position: absolute;
        bottom: -20px;
        left: 6px;
        font-weight: bold;
        font-style: italic;
        transform: translateX(-90%);
        font-family: "Anton", sans-serif;
        text-shadow: -2px 0 $color1, 0 2px $color1, 2px 0 $color1,
          0 -2px $color1;
      }
    }
  }

  .field {
    display: flex;
    padding: 7px 0;
    align-items: center;
    span {
      font-size: 0.8em;
      color: $color1;
      padding: 3px 0;
      width: 100px;
      text-align: center;
      background-color: #eeeef0;
      border-radius: 25px;
      margin-right: 10px;
    }
  }
}
</style>
